<template>
  <UDashboardGroup unit="rem">
    <div class="flex flex-1">
      <UDashboardSidebar
        v-model:open="open"
        resizable
        toggle
        mode="drawer"
      >
        <template #header>
          <NavbarLogo />
        </template>

        <template #default="{ collapsed }">
          <NavbarTeamsMenu :collapsed="collapsed" />
          <UNavigationMenu
            :collapsed="collapsed"
            :items="links[0]"
            orientation="vertical"
            tooltip
            popover
          />
        </template>

        <template #footer="{ collapsed }">
          <div class="flex flex-col gap-2 w-full">
            <NavbarUserMenu :collapsed="collapsed" />
          </div>
        </template>
      </UDashboardSidebar>
    </div>

    <div class="flex overflow-y-scroll flex-col w-full min-h-dvh dark:bg-zinc-900">
      <div class="flex sticky top-0 z-20 flex-row justify-between items-center p-2 lg:hidden backdrop-blur border-b-neutral-200/80 bg-neutral-100/80 dark:border-b-neutral-900/80 dark:bg-neutral-800/80">
        <UDashboardSidebarToggle size="lg" />
        <NavbarLogo />
      </div>

      <div class="flex flex-col px-4 pt-6 pb-8 md:px-8">
        <NuxtPage />
      </div>
    </div>
  </UDashboardGroup>
</template>

<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui'

const open = ref(false)

const links = computed(() => [[
  {
    label: 'Home',
    to: '/admin',
    icon: 'i-lucide-home',
    onSelect: () => {
      open.value = false
    },
  },
  {
    label: 'Teams',
    to: '/admin/teams',
    icon: 'i-lucide-users-round',
  },
  {
    label: 'Users',
    to: '/admin/users',
    icon: 'i-lucide-user-round',
  },
  {
    label: 'Rates',
    to: '/admin/rates',
    icon: 'i-lucide-chart-candlestick',
  },
  {
    label: 'Senders',
    to: '/admin/senders',
    icon: 'i-lucide-contact-round',
  },
]] satisfies NavigationMenuItem[][])
</script>
